import {getDataWithPromise, getParamList, Globals, handleAjaxError, urlExplode} from "./BaseDataFns";
import {
    URL_POST16_REVIEW_TERM_COUNTS,
    URL_POST16_REVIEW_TERM_DATA,
    URL_POST16_REVIEW_TERMS,
    URL_POST_16_TERM_REVIEW,
    URL_SUBMIT_POST_16_TERM_REVIEW,
    URL_UPDATE_CHILD_ATTENDANCE
} from "root/DataFunctions/APIUrls";

export const getProgressReviewsForYearTerm = ( year_term_id, onComplete ) =>
{
    const url = Globals.APIFolder + "/reviews/term/" + year_term_id ;

    // Legacy structures
    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const sendProgressReviewReminder = ( progress_review_id, onComplete ) =>
{
    const url = Globals.APIFolder + "/reviews/" + progress_review_id ;

    // Legacy structures
    getDataWithPromise ( url, 'PUT', { status: 'remind' } )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const deleteProgressReview = ( progress_review_id, onComplete ) =>
{
    const url = Globals.APIFolder + "/reviews/" + progress_review_id ;

    // Legacy structures
    getDataWithPromise ( url, 'DELETE', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const getProgressDataForChild = ( child_id, year_id, onComplete ) =>
{
    const url = Globals.APIFolder + '/children/' + child_id + '/progressdata/year/' + year_id ;

    // Legacy structures
    return getDataWithPromise (url, 'GET', {}) ;
}

export const forceSubmitProgressReview = ( progress_review_id, onComplete ) =>
{
    const url = Globals.APIFolder + "/reviews/" + progress_review_id + '/force';

    // Legacy structures
    getDataWithPromise ( url, 'PUT', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}


export const getProgressReviewDetailsWithPromise = ( review_id ) =>
{
    const url = Globals.APIFolder + '/reviews/' + review_id ;

    return getDataWithPromise (url, 'GET', {}) ;
}


export const getTermBasedProgressReviewDetailsWithPromise = ( academic_year, reviewMode, child_id ) =>
{
    const url = Globals.APIFolder + '/child/' + child_id + '/year/' + academic_year + '/termreviews/' + reviewMode ;

    return getDataWithPromise (url, 'GET', {}) ;
}

export const submitTermBasedProgressReviewDetailsWithPromise = ( academic_year, reviewMode, child_id, data ) =>
{
    const url = Globals.APIFolder + '/child/' + child_id + '/year/' + academic_year + '/termreviews/' + reviewMode ;

    return getDataWithPromise (url, 'POST', data) ;
}

export const getPost16TermReview = ( child_id, academic_year, school_term_id, cprp_id ) =>
{
    const url = Globals.APIFolder + urlExplode ( URL_POST_16_TERM_REVIEW, {child_id: child_id, academic_year: academic_year, school_term_id: school_term_id, cprp_id : cprp_id } ) ;

    return getDataWithPromise (url, 'GET' ) ;
}

export const submitPost16TermReview = ( child_id, cprp_id, formData ) =>
{
    const url = Globals.APIFolder + urlExplode ( URL_SUBMIT_POST_16_TERM_REVIEW, {child_id: child_id, cprp_id : cprp_id } ) ;

    return getDataWithPromise (url, 'POST', formData ) ;
}

export const getPost16ProgressReviewTerms = () =>
{
    const url = Globals.APIFolder + urlExplode ( URL_POST16_REVIEW_TERMS, { } ) ;

    return getDataWithPromise (url, 'GET' ) ;
}

export const getPost16ProgressReviewDataForTerm = ( half_term_review_id ) =>
{
    const url = Globals.APIFolder + urlExplode ( URL_POST16_REVIEW_TERM_DATA, { half_term_review_id: half_term_review_id} ) ;

    return getDataWithPromise (url, 'GET' ) ;
}


export const getPost16ProgressReviewCountsForTerm = ( half_term_review_id ) =>
{
    const url = Globals.APIFolder + urlExplode ( URL_POST16_REVIEW_TERM_COUNTS, { half_term_review_id: half_term_review_id} ) ;

    return getDataWithPromise (url, 'GET' ) ;
}

